export const DIALOG_MANAGE_MODE = {
  ADD: "add",
  EDIT: "edit"
};
